const _clipboard = require('clipboard');

exports.init = function Clipboard() {
  new _clipboard('[data-clipboard-target]');
}
